export enum ChargePayer {
  USER = "user",
  CPO = "cpo",
}
